import React from "react";

export const UnicornFallback = () => (
    <div style={{ textAlign: "center", padding: "2rem" }}>
        <h1>🦄 Oops! Something magical went wrong.</h1>
        <p>Please try again later. Developer team has been notified.</p>
    </div>
);
